
    import { Component, Emit, Prop, Vue } from 'nuxt-property-decorator';
    import { namespace } from 'nuxt-property-decorator';
    import { getComponentsMap } from '@/components';
    import { getComponentMeta } from '@/store/editor';
    import { makeObject } from '@/components/editor/utils/editor';
    import OptionsFields from '@/components/editor/options/OptionsFields.vue';
    import OptionsFieldsComponent from '@/components/editor/options/fields/OptionsFieldsComponent.vue';
    import { PageComponent } from '@/store/page';
    import { AvailableGroups } from '@/components/editor/config/types';
    import ComponentsList from '@/components/editor/component/ComponentsList.vue';

    let editor = namespace('editor');

    @Component({
        components: { ComponentsList, OptionsFieldsComponent, OptionsFields }
    })
    export default class OptionsFieldsFullComponentsList extends Vue {
        @Prop() value;
        @Prop() entity;
        @Prop() filter;
        @Prop({ default: false }) multiple: boolean;
        @editor.State components;
        @editor.State componentsList;

        selected: PageComponent | null = null;
        values = [] as any;

        @Emit('input')
        onChange(val: string) {
            const meta = getComponentMeta(val);

            if (!meta) {
                return;
            }

            let options = makeObject(meta.options);
            return {
                name: val,
                active: true,
                options
            };
        }

        mounted() {
            //console.log(this.componentsList);

            this.values = [
                {
                    text: 'Нет компонента',
                    value: null
                }
            ];

            const componentsListWithGroups = getComponentsMap();

            let keys = Object.keys(componentsListWithGroups);

            keys = keys.filter(k => {
                const meta = getComponentMeta(k);

                return !meta || (meta && !meta.inner);
            });
            const groups = {};

            keys.forEach(a => {
                const meta = getComponentMeta(a);

                if (!meta) {
                    return;
                }

                if (!groups[meta.group]) {
                    groups[meta.group] = [];
                }
                groups[meta.group].push(a);
            });

            let newKeys: string[] = [];

            for (let group in groups) {
                newKeys = [...newKeys, ...groups[group]];
            }

            for (let name of newKeys) {
                const meta = getComponentMeta(name);

                if (meta) {
                    if (
                        (this.filter &&
                            typeof this.filter === 'function' &&
                            this.filter(meta)) ||
                        !this.filter
                    ) {
                        this.values.push({
                            text: meta
                                ? `${
                                      AvailableGroups[meta.group]
                                          ? AvailableGroups[meta.group]
                                          : 'Общие'
                                  } | ${meta.title}`
                                : '',
                            value: name
                        });
                    }
                }
            }

            if (!this.value) {
                this.values.forEach((val: any) => {
                    if (val.selected) {
                        this.selected = val.value;
                    }
                });
            } else {
                this.selected = this.value.name;
            }
        }

        updated() {
            if (!this.value) {
                this.values.forEach((val: any) => {
                    if (val.selected) {
                        this.selected = val.value;
                    }
                });
            } else {
                this.selected = this.value.name;
            }
        }
    }
